import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["text"];
import "core-js/modules/es.string.trim.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Background } from "../../Background/Background";
import { BackgroundImage } from "../../Image/BackgroundImage/BackgroundImage";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Breakpoints } from "../../Responsive/Breakpoints/Breakpoints";
import { Button } from "../../Button/Button/Button";
import { Container } from "../../Container/Container/Container";
import { Image } from "../../Image/Image/Image";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { OfferBanner } from "../../Banner/OfferBanner/OfferBanner";
import { SourceSet } from "../../Responsive/SourceSet/SourceSet";
import { Text } from "../../Text/Text/Text";
import Browser from "../../Utility/Browser";
import Colors from "../../Color/Colors";
import Utility from "../../Utility/Utility";
import styles from "./ColorBlockMastheadSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var colorBlockMastheadEyebrowTypogs = ['eyebrow2', 'eyebrow3'];
export var colorBlockMastheadHeadlineTypogs = ['headline2', 'headline3'];
export var ColorBlockMastheadSlice = function ColorBlockMastheadSlice(_ref) {
  var _offerBanner$text, _offerBanner$popup, _offerBanner$text2, _image$mobile, _image$desktop;
  var _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? Colors.colorWW100 : _ref$backgroundColor,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'darkBackground' : _ref$theme,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? {
      text: '',
      typog: 'eyebrow2'
    } : _ref$eyebrow,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? {
      ariaLevel: 1,
      text: '',
      typog: 'headline2'
    } : _ref$headline,
    _ref$bodyText = _ref.bodyText,
    bodyText = _ref$bodyText === void 0 ? '' : _ref$bodyText,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {
      url: '',
      text: '',
      type: 'primary',
      newWindow: false
    } : _ref$cta,
    _ref$ctaTwo = _ref.ctaTwo,
    ctaTwo = _ref$ctaTwo === void 0 ? {
      url: '',
      text: '',
      type: 'primary',
      newWindow: false
    } : _ref$ctaTwo,
    image = _ref.image,
    _ref$fullWidthBackgro = _ref.fullWidthBackground,
    fullWidthBackground = _ref$fullWidthBackgro === void 0 ? false : _ref$fullWidthBackgro,
    _ref$bgSizeContain = _ref.bgSizeContain,
    bgSizeContain = _ref$bgSizeContain === void 0 ? false : _ref$bgSizeContain,
    _ref$forceOneX = _ref.forceOneX,
    forceOneX = _ref$forceOneX === void 0 ? false : _ref$forceOneX,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? {} : _ref$icon,
    offerBanner = _ref.offerBanner,
    _ref$blockWidthFiftyP = _ref.blockWidthFiftyPercent,
    blockWidthFiftyPercent = _ref$blockWidthFiftyP === void 0 ? false : _ref$blockWidthFiftyP,
    _ref$footnote = _ref.footnote,
    footnote = _ref$footnote === void 0 ? '' : _ref$footnote,
    _ref$mobileOverlay = _ref.mobileOverlay,
    mobileOverlay = _ref$mobileOverlay === void 0 ? false : _ref$mobileOverlay,
    _ref$mobileLayoutReve = _ref.mobileLayoutReverse,
    mobileLayoutReverse = _ref$mobileLayoutReve === void 0 ? false : _ref$mobileLayoutReve;
  var minBackgroundHeight = 650;
  var _useState = useState(minBackgroundHeight),
    _useState2 = _slicedToArray(_useState, 2),
    contentHeight = _useState2[0],
    setContentHeight = _useState2[1];
  var contentRef = useRef(null);
  useEffect(function () {
    if (Browser.isBrowser()) {
      // Component mount.
      window.addEventListener('resize', setBackgroundHeight);
      // Component unmount.
      return function () {
        window.removeEventListener('resize', setBackgroundHeight);
      };
    }
  }, []);
  useEffect(function () {
    setBackgroundHeight();
  }, [
  // Dependancy array of props which can change the height.
  eyebrow, headline, bodyText, cta, ctaTwo, image, fullWidthBackground, bgSizeContain, forceOneX, icon, offerBanner, blockWidthFiftyPercent, footnote, mobileOverlay, mobileLayoutReverse]);
  var setBackgroundHeight = function setBackgroundHeight() {
    if (Browser.isBrowser()) {
      setContentHeight(contentRef.current ?
      // Mobile.
      window.innerWidth < Breakpoints.medium.min ? 'auto' :
      // Desktop with content height <= 650px.
      contentRef.current.getBoundingClientRect().height <= minBackgroundHeight ? minBackgroundHeight :
      // Desktop with content height greater than 650px.
      contentRef.current.getBoundingClientRect().height : 'auto');
    }
  };
  var renderCTA = function renderCTA(cta) {
    var text = cta.text,
      otherProps = _objectWithoutProperties(cta, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, otherProps), {}, {
      children: /*#__PURE__*/_jsx(Text, {
        className: styles.ctaText,
        richText: true,
        textElement: "span",
        typog: "bodycopy",
        children: text
      })
    }));
  };
  var renderBackgroundImage = function renderBackgroundImage(img, img2x, posY, alt, oneXWidth, twoXWidth) {
    var bgSizeContain = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var oneX = Utility.getOptimizedCloudinaryUrl(img, {
      width: oneXWidth
    }, true);
    var twoX = Utility.getOptimizedCloudinaryUrl(img2x, {
      width: twoXWidth
    }, true);
    var bgSize = bgSizeContain ? 'contain' : 'cover';
    var ariaLabel = alt.trim() || undefined;
    var role = !!ariaLabel ? 'img' : undefined;
    var oneXImage = /*#__PURE__*/_jsx(BackgroundImage, {
      uri: oneX,
      positionY: fullWidthBackground || mobileOverlay ? posY : '',
      "aria-label": ariaLabel,
      role: role,
      bgSize: bgSize
    });
    var twoXImage = /*#__PURE__*/_jsx(BackgroundImage, {
      uri: twoX,
      positionY: fullWidthBackground || mobileOverlay ? posY : '',
      "aria-label": ariaLabel,
      role: role,
      bgSize: bgSize
    });
    return forceOneX ? oneXImage : /*#__PURE__*/_jsxs(SourceSet, {
      children: [oneXImage, img2x && twoXImage]
    });
  };
  var hasOfferBanner = (offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$text = offerBanner.text) === null || _offerBanner$text === void 0 ? void 0 : _offerBanner$text.text) || (offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$popup = offerBanner.popup) === null || _offerBanner$popup === void 0 ? void 0 : _offerBanner$popup.title);
  var hasCtaTwo = (ctaTwo === null || ctaTwo === void 0 ? void 0 : ctaTwo.text) && (ctaTwo === null || ctaTwo === void 0 ? void 0 : ctaTwo.url);
  var backgroundHeight = bgSizeContain ? 300 : minBackgroundHeight;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.background, fullWidthBackground && styles.backgroundFullWidth, mobileOverlay && styles.backgroundMobileOverlay, mobileLayoutReverse && styles.backgroundMobileLayoutReverse),
    style: {
      backgroundColor: backgroundColor,
      height: fullWidthBackground ? contentHeight : undefined
    },
    children: [/*#__PURE__*/_jsx("div", {
      ref: contentRef,
      className: classnames(styles.content, {
        [styles.blockWidthFiftyPercent]: !fullWidthBackground && blockWidthFiftyPercent,
        // 50% width functionality only enabled for legacy CBM.
        [styles.contentFullWidth]: fullWidthBackground,
        [styles.contentBgSizeContain]: bgSizeContain,
        [styles.contentMobileOverlay]: mobileOverlay
      }),
      style: {
        minHeight: fullWidthBackground && contentHeight <= backgroundHeight ? '100%' : undefined,
        backgroundColor: fullWidthBackground || mobileOverlay ? backgroundColor : 'none'
      },
      children: /*#__PURE__*/_jsx(Background, {
        color: backgroundColor,
        theme: theme,
        children: /*#__PURE__*/_jsxs(Container, {
          className: classnames(styles.container, {
            [styles.containerFullWidth]: fullWidthBackground,
            [styles.containerBgSizeContain]: fullWidthBackground && bgSizeContain
          }),
          children: [(icon === null || icon === void 0 ? void 0 : icon.image1x) && /*#__PURE__*/_jsx("div", {
            className: styles.icon,
            children: /*#__PURE__*/_jsx(Image, {
              src: icon.image1x,
              alt: icon.alt,
              width: icon.width,
              height: icon.height,
              transformations: {
                image1x: {
                  width: parseInt(icon.width || '', 10) || undefined
                },
                image2x: {
                  width: parseInt(icon.width || '', 10) * 2 || undefined
                }
              },
              forceTwoXInSrc: true,
              loading: "eager"
            })
          }), (eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) && /*#__PURE__*/_jsx(Text, {
            className: styles.eyebrow,
            richText: true,
            typog: eyebrow.typog,
            children: eyebrow.text
          }), (headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(HeadingText, {
            ariaLevel: headline.ariaLevel,
            className: styles.headline,
            richText: true,
            typog: headline.typog,
            children: headline.text
          }), hasOfferBanner && /*#__PURE__*/_jsx(OfferBanner, {
            className: styles.offerBanner,
            popup: _objectSpread({}, offerBanner === null || offerBanner === void 0 ? void 0 : offerBanner.popup),
            text: {
              text: offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$text2 = offerBanner.text) === null || _offerBanner$text2 === void 0 ? void 0 : _offerBanner$text2.text,
              typog: 'bodycopyLarge'
            }
          }), bodyText !== null && /*#__PURE__*/_jsx(Text, {
            className: styles.body,
            typog: "bodycopyLarge",
            richText: true,
            children: bodyText
          }), (cta === null || cta === void 0 ? void 0 : cta.text) && (cta === null || cta === void 0 ? void 0 : cta.url) && /*#__PURE__*/_jsxs("div", {
            className: classnames(styles.ctaWrapper, !hasCtaTwo && styles.ctaWrapperDefault, !footnote && bgSizeContain && styles.ctaMarginWithoutFootnote),
            children: [/*#__PURE__*/_jsx("div", {
              className: classnames(styles.cta, !hasCtaTwo && !fullWidthBackground && !mobileOverlay && styles.ctaDefault),
              children: renderCTA(cta)
            }), hasCtaTwo && /*#__PURE__*/_jsx("div", {
              className: styles.ctaTwo,
              children: renderCTA(ctaTwo)
            })]
          }), footnote && /*#__PURE__*/_jsx(Text, {
            typog: "captionSmall",
            richText: true,
            children: footnote
          })]
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.image, fullWidthBackground && styles.imageFullWidth, mobileOverlay && styles.imageMobileOverlay,
      // 50% width functionality only enabled for legacy CBM.
      {
        [styles.blockWidthFiftyPercent]: !fullWidthBackground && !mobileOverlay && blockWidthFiftyPercent
      }, bgSizeContain && styles.bgSizeContainMinHeight),
      children: /*#__PURE__*/_jsxs(Breakpoint, {
        breakpoint: fullWidthBackground || mobileOverlay ? 'medium' : 'small',
        children: [(image === null || image === void 0 ? void 0 : (_image$mobile = image.mobile) === null || _image$mobile === void 0 ? void 0 : _image$mobile.image1x) && renderBackgroundImage(image.mobile.image1x, image.mobile.image2x ? image.mobile.image2x : '', 'top', image.alt || '', 990, 1980), (image === null || image === void 0 ? void 0 : (_image$desktop = image.desktop) === null || _image$desktop === void 0 ? void 0 : _image$desktop.image1x) && renderBackgroundImage(image.desktop.image1x, image.desktop.image2x ? image.desktop.image2x : '', 'center', image.alt || '', 2000, 2800, bgSizeContain)]
      })
    })]
  });
};